export default "__VITE_ASSET__kYNs1Etr__"